import {
  ICS204_PREPARED_BY_SIGN_ROLE,
  type WalaSignature,
} from 'components/IAP/planningView/widgets/AssignmentList/ics204SignatureSlots';

export const ICS213RR_BASE_ID = 'ICS_213RR';

export const ICS213RR_SECTION_CHIEF_ROLE = 'Section Chief';
export const ICS213RR_RESL_ROLE = 'Resource Unit Leader';
export const ICS213RR_LOGISTICS_ROLE = 'Logistics Section Chief';
export const ICS213RR_FINANCE_ROLE = 'Finance Section Chief';

/** Seat permission required to sign each printed box, keyed by slot id. */
export const ICS213RR_SLOT_PERMISSION: Record<string, string> = {
  requestedBy: 'resourceRequest:signRequestedBy',
  sectionChief: 'resourceRequest:signSectionChief',
  reslReview: 'resourceRequest:signResl',
  logisticsApproval: 'resourceRequest:signLogistics',
  financeApproval: 'resourceRequest:signFinance',
};

export { ICS204_PREPARED_BY_SIGN_ROLE as ICS213RR_REQUESTED_BY_ROLE };

export function is213rrSlotSigned(
  signatures: WalaSignature[] | null | undefined,
  role: string
): boolean {
  return (signatures ?? []).some((signature) => signature.role === role);
}

/** Default reject notify recipient: userGuid of the last tip stamp by signedAt. */
export function defaultRejectRecipientUserGuid(
  signatures: WalaSignature[] | null | undefined
): string | null {
  const list = signatures ?? [];
  if (list.length === 0) return null;
  let last = list[0];
  for (let i = 1; i < list.length; i += 1) {
    const candidate = list[i];
    if ((candidate.signedAt ?? 0) >= (last.signedAt ?? 0)) {
      last = candidate;
    }
  }
  const guid = last?.userGuid?.trim();
  return guid || null;
}
